import React, { useState } from "react";
import { useHistory } from "react-router";
import { Box, Grid, InputAdornment, TextField, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsIcon from "@material-ui/icons/Notifications";
import clsx from "clsx";
import { logOutAction } from "src/app-redux/auth/actions/authActions";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import NLCLogo from "src/assets/images/logo_sidebar_collapsed.png";
import { DRAWER_WIDTH } from "./SideNav";
import NotificationDrawer from "../NotificationDrawer/NotificationDrawer";
import { unreadCountValue } from "src/app-redux/notifications/notificationSlice";
import { setIsLoggedIn } from "src/app-redux/auth/authSlice";
import TransitionDialog from "../AlertDialog/TransitionDialog";
import { useFormik } from "formik";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import * as Yup from "yup";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.modal,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },

    appBarShift: {
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      marginLeft: DRAWER_WIDTH,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    backdrop: {
      zIndex: theme.zIndex.drawer,
      color: "#fff",
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
      marginTop: "10px",
    },
    iconOnDrawerOpen: {
      color: "#E67817 !important",
      "& .MuiSvgIcon-root": {
        fontSize: "22px",
      },
      "& .MuiBadge-badge": {
        backgroundColor: "black",
        color: "white",
      },
    },
    iconOnDrawerClose: {
      color: "black",
      "& .MuiSvgIcon-root": {
        fontSize: "22px",
      },
      "& .MuiBadge-badge": {
        backgroundColor: "#E67817",
        color: "white",
      },
    },
  })
);

type Props = { open: boolean; toggleDrawer: () => void };

export function Header(props: Props) {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const count = useAppSelector(unreadCountValue);
  const terminalName = localStorage.getItem("terminalName");
  // };
  /* NEW */
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const menuId = "primary-search-account-menu";

  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const formik = useFormik<any>({
    initialValues: {
      userId: "",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required("Current Password is required"),
      newPassword: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("New Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (values) => {
      handleCloseChangePasswordDialog();
      const body = {
        userId: localStorage.getItem("nodUserId"),
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      };
      const res = await fetchWrapper.post("change_password", body);
      console.log(res?.value?.isPasswordUpdated);

      if (!res?.value?.isPasswordUpdated) {
        setIsOpenChangePasswordDailog(true);
      }
    },
  });
  const [currentPasswordState, setCurrentPasswordState] = useState({ showPassword: false });
  const [newPasswordState, setNewPasswordState] = useState({ showPassword: false });
  const [confirmPasswordState, setConfirmPasswordState] = useState({ showPassword: false });

  const handleClickShowCurrentPassword = () => {
    setCurrentPasswordState({
      ...currentPasswordState,
      showPassword: !currentPasswordState.showPassword,
    });
  };
  const handleClickShowNewPassword = () => {
    setNewPasswordState({
      ...newPasswordState,
      showPassword: !newPasswordState.showPassword,
    });
  };
  const handleClickShowConfirmPassword = () => {
    setConfirmPasswordState({
      ...confirmPasswordState,
      showPassword: !confirmPasswordState.showPassword,
    });
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const [isOpenChangePasswordDailog, setIsOpenChangePasswordDailog] = useState<boolean>(false);
  const handleSubmitChangePasswordDialog = () => {
    formik.submitForm();
  };
  const handleCloseChangePasswordDialog = () => {
    setIsOpenChangePasswordDailog(false);
    formik.resetForm();
  };

  return (
    <>
      <NotificationDrawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: props.open,
        })}
      >
        <Toolbar className="toolBar">
          <Grid justifyContent="space-between" container>
            <Grid item>
              <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                <Box mt={1} mb={1} my={1}>
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={props.toggleDrawer}
                    edge="start"
                  >
                    {props.open ? <ChevronLeftIcon /> : <MenuIcon />}
                  </IconButton>
                </Box>
                {!props.open && (
                  <Box mt={1} mb={1} my={1}>
                    <img src={NLCLogo} alt="logo" width="40" />
                  </Box>
                )}
                <Typography style={{ color: "black", paddingLeft: "10px" }}>
                  {terminalName}
                </Typography>
              </Grid>
            </Grid>
            <Grid item>
              <div className={classes.sectionDesktop}>
                {Number(localStorage.getItem("terminalType")) == 0 && (
                  <IconButton
                    className={isDrawerOpen ? classes.iconOnDrawerOpen : classes.iconOnDrawerClose}
                    onClick={() => {
                      setisDrawerOpen(true);
                    }}
                  >
                    <Badge badgeContent={count}>
                      <NotificationsIcon />
                    </Badge>
                  </IconButton>
                )}
                <IconButton
                  edge="end"
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="inherit"
                  className="headerTopUserInfo"
                >
                  <AccountCircle />
                  <Typography className="userName">
                    {localStorage.getItem("nodUserFullName")}
                  </Typography>
                  <ExpandMoreIcon className="downArrow"></ExpandMoreIcon>
                </IconButton>
                <Menu
                  style={{ display: !isOpenChangePasswordDailog ? "block" : "none" }}
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={open}
                  onClose={handleClose}
                >
                  <MenuItem onClick={() => setIsOpenChangePasswordDailog(true)}>
                    Change Password
                  </MenuItem>
                  <MenuItem
                    onClick={async () => {
                      await dispatch(logOutAction());
                      localStorage.clear();
                      dispatch(setIsLoggedIn(false));
                      history.push("/auth/login");
                      // if (res.payload as string) {
                      //   localStorage.clear();
                      //   history.push("/auth/login");
                      // }
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <TransitionDialog
        isOpen={isOpenChangePasswordDailog}
        handleClose={() => handleCloseChangePasswordDialog()}
        heading={"Change Password"}
        handleConfirm={() => handleSubmitChangePasswordDialog()}
        confirmButton="Change"
        cancelButton="Cancel"
      >
        <Box style={{ marginTop: "10px", marginBottom: "10px", width: "300px" }}>
          <Grid container direction="row" alignItems="center" spacing={2}>
            <Grid item xs={12} md={12}>
              <TextField
                required
                size="small"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Current Password"
                className="customTextField"
                name="currentPassword"
                placeholder="Enter Current Password"
                type={currentPasswordState.showPassword ? "text" : "password"}
                value={formik.values.currentPassword}
                onChange={formik.handleChange}
                error={formik.touched.currentPassword && Boolean(formik.errors.currentPassword)}
                helperText={formik.touched.currentPassword && formik.errors.currentPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowCurrentPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {currentPasswordState.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                required
                size="small"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="New Password"
                className="customTextField"
                name="newPassword"
                placeholder="Enter New Password"
                type={newPasswordState.showPassword ? "text" : "password"}
                value={formik.values.newPassword}
                onChange={formik.handleChange}
                error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
                helperText={formik.touched.newPassword && formik.errors.newPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowNewPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {newPasswordState.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <TextField
                required
                size="small"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Confirm Password"
                className="customTextField"
                name="confirmPassword"
                placeholder="Enter Confirm Password"
                type={confirmPasswordState.showPassword ? "text" : "password"}
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowConfirmPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {newPasswordState.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </TransitionDialog>
    </>
  );
}
